module.exports = __webpack_public_path__ + "static/media/weiteres-produkt_icn.6b3b522f.svg";